

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"20","height":"13","viewBox":"0 0 20 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M9.99577 8.75972L17.478 1.27778C17.6836 1.07177 17.9584 0.958433 18.2514 0.958433C18.5446 0.958433 18.8192 1.07177 19.025 1.27778L19.6803 1.93339C19.8865 2.13908 20 2.41404 20 2.70705C20 3.00006 19.8865 3.27469 19.6803 3.48054L10.772 12.389C10.5655 12.5956 10.2896 12.7088 9.99626 12.708C9.70163 12.7088 9.42602 12.5958 9.21935 12.389L0.319675 3.48883C0.113497 3.28298 0 3.00835 0 2.71518C0 2.42217 0.113497 2.14754 0.319675 1.94152L0.97496 1.28607C1.40146 0.859571 2.09577 0.859571 2.52211 1.28607L9.99577 8.75972Z","fill":"#342245"}, []), "\n"]);
};

        